import React from 'react';

const IsFetchingInline = (props) => {
  return <span>{props.isFetching && <img src="/static/base/images/ajax-loader-line.gif"/>}</span>
};

export default IsFetchingInline;